import { render, staticRenderFns } from "./list-info.vue?vue&type=template&id=50966204&scoped=true"
import script from "./list-info.vue?vue&type=script&lang=ts"
export * from "./list-info.vue?vue&type=script&lang=ts"
import style0 from "./list-info.vue?vue&type=style&index=0&id=50966204&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50966204",
  null
  
)

export default component.exports